import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import SchoolSupport from "@/pages/SchoolSupport";
import SocialSkillsGroup from "@/pages/SocialSkillsGroup";
import AgesPrograms from "@/pages/AgesPrograms";
import AdultSocialSkills from "@/pages/AdultSocialSkills";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/school-support" element={<SchoolSupport />} />
        <Route path="/social-skills-group" element={<SocialSkillsGroup />} />
        <Route path="/ages-programs" element={<AgesPrograms />} />
        <Route path="/adult-social-skills" element={<AdultSocialSkills />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
